import React from "react"
import PropTypes from "prop-types"
import {Link, withRouter} from 'react-router-dom';
import {Button, Col, FormControl, FormGroup, Glyphicon, InputGroup, Row} from "react-bootstrap"
import {TableHeaderColumn} from "react-bootstrap-table"
import BaseGrid from "../BaseGrid"
import FormButtons from "../form/FormButtons"
import {Date, Grid} from "../../utils"
import {formatDog, formatParty} from "../../utils/format";

class Walks extends BaseGrid {

	constructor(props) {
		super(props);

		this.state = {
			...this.state,
			action: null,
			actionModalOpen: null,
			actionItems: []
		};

		this.handleActionSelect = this.handleActionSelect.bind(this);
		this.handleActionSubmit = this.handleActionSubmit.bind(this);
		this.handleRowSelect = this.handleRowSelect.bind(this);
		this.handleRowSelectAll = this.handleRowSelectAll.bind(this);

		this.handleActionModalDismiss = this.handleActionModalDismiss.bind(this)
	}

	getDefaultFilter() {
		return {
			"statuses": "ACTIVE",

			"search": "",
			"orderCol": "walkDate",
			"orderDir": "a",
			"start": 0,
			"rows": this.getDefaultPageRows()
		}
	}

	handleRowSelect({walkId}, isSelected) {
		const {actionItems} = this.state;
		if (isSelected) {
			this.setState({
				actionItems: [...actionItems, walkId].sort()
			});
		} else {
			this.setState({actionItems: actionItems.filter(it => it !== walkId)});
		}
		return false;
	}

	handleRowSelectAll(isSelected) {
		const {items} = this.props;
		if (!isSelected) {
			this.setState({actionItems: []})
		} else {
			const actionItems = [];
			for (let i = 0; i < items.length; i++) {
				actionItems.push(items[i].walkId)
			}
			this.setState({actionItems: actionItems})
		}
	}

	handleActionSelect(action) {
		this.setState({action: action})
	}

	handleActionSubmit() {
		const {actionItems, action} = this.state;
		if (!actionItems || !actionItems.length || !action || !action.value) {
			return
		}

		if ("delete" === action.value) {
			this.props.onShowModal(
				'Hromadné smazání vycházek',
				'Skutečně hromadně smazat vycházky (' + actionItems.length + ')?',
				{style: 'danger', label: 'Hromadně smazat vycházky', icon: 'trash'},
				() => this.props.onUpdateWalkStatus("deleted", actionItems).then((json) => {
					if (json && json.response && json.response.result === 'OK') {
						this.onFilterChange()
					} else {
						return new Promise((resolve, reject) => reject())
					}
				})
			)

		} else if ("finish" === action.value) {
			this.props.onShowModal(
				'Hromadné ukončení vycházek',
				'Skutečně hromadně ukončit vybrané vycházky (' + actionItems.length + ')?',
				{style: 'success', label: 'Hromadně ukončit', icon: 'ok'},
				() => this.props.onUpdateWalkStatus("finished", actionItems).then((json) => {
					if (json && json.response && json.response.result === 'OK') {
						this.props.onShowMessage('Vycházky ukončeny (' + json.response.data + ')');
						this.onFilterChange()
					} else {
						return new Promise((resolve, reject) => reject())
					}
				})
			)
		} else {
			this.setState({actionModalOpen: true})
		}
	}

	handleActionModalDismiss() {
		this.setState({actionModalOpen: false})
	}

	renderActionModal() {
		// const {session} = this.props;
		const {actionModalOpen, actionItems} = this.state;
		if (!actionModalOpen) {
			return null
		}
		const {items} = this.props;
		const selected = [];
		if (items && items.length) {
			for (let i = 0; i < items.length; i++) {
				if (actionItems.indexOf(items[i].walkId) >= 0) {
					selected.push(items[i])
				}
			}
		}
	}

	formatStatus(cell, row) {
		switch (cell) {
			case "ACTIVE":
				return "Aktivní";
			case "FINISHED":
				return "Ukončená";
			case "DELETED":
				return "Smazaná";
			default:
				return cell
		}
	}

	formatWalkDate(cell, row) {
		return <Link to={{pathname: "/vychazky/" + row.walkId}}>{Date.formatDate(cell)}</Link>
	}

	formatActions(cell, row) {
		return <span>
			<Link to={{pathname: "/vychazky/" + row.walkId}} className="btn">detail</Link>
			&nbsp;
			<Link to={{pathname: "/vychazky/" + row.walkId + "/uprava"}} className="btn">upravit</Link>
		</span>
	}

	formatRow(row, index) {
		return (row && row.status === 'DELETED' ? "alert-muted" : null)
	}

	getFilter() {
		const {filter} = this.state;

		const statuses = [
			{value: 'ACTIVE', label: 'Aktivní'},
			{value: 'FINISHED', label: 'Ukončená'},
			{value: 'DELETED', label: 'Smazaná'}
		];

		return [
			<Row key="1">
				<Col xs={6}>
					<FormGroup>
						<InputGroup>
							<FormControl type="text" value={filter.search} name="search" placeholder="Příjmení, email" onChange={this.handleInputChange}/>
							<div className="input-group-btn">
								{filter.search ? <span className={"btn-clear-text"} onClick={this.onFilterReset}>×</span> : null}
								<Button type="submit" bsStyle="info">
									<Glyphicon glyph="search"/> <span className={"hidden-sm hidden-xs"}>Vyhledat</span></Button>
							</div>
						</InputGroup>
					</FormGroup>
				</Col>
				<Col xs={6}>
					<Row>
						<Col xs={7}>
							<FormButtons currentValue={filter.statuses} options={statuses} name="statuses" onInputChange={this.handleInputChange}/>
						</Col>
						{Grid.renderFilterButtons(this.onFilterReset, 5)}
					</Row>
				</Col>
			</Row>];
	}

	getCols() {
		return [
			<TableHeaderColumn key="0" dataField="walkId" width='5%' dataAlign="center" dataSort={true}>#</TableHeaderColumn>,
			<TableHeaderColumn key="1" dataField="walkDate" width='10%' dataAlign="center" dataFormat={this.formatWalkDate} dataSort={true}>Datum</TableHeaderColumn>,
			<TableHeaderColumn key="2" dataField="partyLastName" width='40%' dataAlign="center" dataSort={true} dataFormat={(_, r) => formatParty(r)}>Venčitel</TableHeaderColumn>,
			<TableHeaderColumn key="3" dataField="dogName" width='25%' dataAlign="center" dataSort={true} dataFormat={(_, r) => formatDog(r)}>Pes</TableHeaderColumn>,
			<TableHeaderColumn key="4" dataField="status" width='10%' dataAlign="center" dataFormat={this.formatStatus}>Stav</TableHeaderColumn>,
			<TableHeaderColumn key="5" dataField="walkId" width='10%' dataAlign="center" dataFormat={this.formatActions}>&nbsp;</TableHeaderColumn>
		];
	}

	render() {
		const {isFetchingItems, items, count, filter} = this.props;

		const actions = [];
		// actions.push({
		// 	value: "delete",
		// 	label: "Hromadně smazat vycházky"
		// });
		actions.push({
			value: "finish",
			label: "Hromadně ukončit vycházky"
		});
		const actionCtx = {
			onActionSelect: this.handleActionSelect,
			onActionSubmit: this.handleActionSubmit,
			value: this.state.action,
			key: 'walkId',
			selectRowProp: {
				mode: 'checkbox',
				clickToSelect: true,
				onSelect: this.handleRowSelect,
				onSelectAll: this.handleRowSelectAll,
				selected: this.state.actionItems,
				bgColor: function (row, isSelect) {
					if (isSelect) {
						return "#fcf8e3"
					}
					return null;
				},
				unselectable: []
			},
			actions: actions
		};

		return <div>{Grid.renderFull(isFetchingItems, items, count,
			Grid.getTableOptions(filter, this.onPageChange, this.onSortChange, this.onFilterChange, this.renderPaginationShowsTotal),
			this.getCols(),
			this.getFilter(),
			this.onFilterChange,
			actionCtx, this.formatRow)}
			{this.renderActionModal()}
		</div>
	}
}


Walks.propTypes = {
	onFetchEnums: PropTypes.func.isRequired,
	enums: PropTypes.object.isRequired,
	onShowModal: PropTypes.func.isRequired,
	onUpdateWalkStatus: PropTypes.func,
	onShowMessage: PropTypes.func.isRequired
};

export default withRouter(Walks)



// WEBPACK FOOTER //
// ./src/components/walk/Walks.js